/**
 * @author sai shiva
 * @Date: 2022-12-02 12:40:55
 * @Last Modified by: sai shiva
 * @Last Modified time: 2022-12-02 14:30:55
*/

import styled, { css } from 'styled-components';

const SubTitle = styled.h2`
  font-family: 'Mulish', sans-serif;
  font-size: 30px;
  font-weight: 500 !important;
  letter-spacing: 0px !important;
  line-height: 40px;
  ${({ fontSize }) => fontSize && css`font-size: ${fontSize} !important;`}
  ${({ fontWeight }) => fontWeight && css`font-weight: ${fontWeight} !important;`}
  ${({ lineHeight }) => lineHeight && css`line-height: ${lineHeight} !important;`}
`;

SubTitle.displayName = 'h2';
export default SubTitle;



// WEBPACK FOOTER //
// client/components/TitleTypography/SubTitle.js